module.exports = new __parcel__URL__("space_elixir_mine_level_11.03ea10af.png").toString();